export enum MaintenanceStatus {
    Reminder = "Reminder",
    Draft = "Draft",
    Planned = "Planned",
    InProgress = "InProgress",
    Completed = "Completed"
}

export interface VehicleMaintenanceDto {
    id: string;
    ownerId: string;
    vehicleId : string;
    plannedMaintenanceDateTime?: string;
    plannedMaintenanceDuration?: number;
    maintenanceDateTime?: string;
    maintenanceDuration?: number;
    odometerReading?: number;
    status: MaintenanceStatus;
    comment?: string;
    modifiedAt: Date;
    modifyUserName: string;
}
